// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../../../../styles/helpers.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.react-tabs__tab--selected {
    font-weight: 600;
    color: text;
    border-bottom: 3px solid gtBlue;
  }

.react-tabs__tab {
    opacity: 1;
    height: 50px;
    cursor: pointer;
    padding: 16px 10px;
    text-transform: capitalize;
  }

.styles__actionButton___YUXCj {
  display: flex;
  align-self: center;
}

.styles__cardMarginBot___rBx4s {
}

.styles__fullWidth___qCiP5 {
  width: 100%;
}

.styles__contentContainer___bsCgu {
  display: flex;
  flex-flow: row wrap;
  padding-bottom: 20px;
  padding-top: 20px;
}

.styles__contentContainer___bsCgu:before {
  content: '';
  display: table;
}

.styles__contentContainer___bsCgu:after {
  content: '';
  display: table;
  clear: both;
}

.styles__form___A4MuD {
  display: flex;
  flex-flow: column nowrap;
}

.styles__formItem___jVahs {
}

.styles__formItemHalf___UzKer {
}

.styles__formItemQuarter___VKfpu {
}

.styles__formWrapper___v3Svi {
  width: calc(99.9% * 2/3 - (30px - 30px * 2/3));
}

.styles__formWrapper___v3Svi:nth-child(1n) {
  float: left;
  margin-right: 30px;
  clear: none;
}

.styles__formWrapper___v3Svi:last-child {
  margin-right: 0;
}

.styles__formWrapper___v3Svi:nth-child(3n) {
  margin-right: 0;
  float: right;
}

.styles__formWrapper___v3Svi:nth-child(3n + 1) {
  clear: both;
}

.styles__headerSection___jqFD0 {
  min-height: 80px;
}

.styles__headerTitle___va7Nk {
  float: left;
}

.styles__link___bcA_J {
  background: rgba(255, 255, 255, 0.7);
  box-shadow: none;
  display: block;
}

.styles__link___bcA_J:hover {
    background: white;
    box-shadow: none;
  }

.styles__menuLink___Txbgw {
  color: gtGreen;
  display: flex;
  align-self: center;
}

.styles__menuWrapper___jaBEt {
  width: calc(99.9% * 1/3 - (30px - 30px * 1/3));
}

.styles__menuWrapper___jaBEt:nth-child(1n) {
  float: left;
  margin-right: 30px;
  clear: none;
}

.styles__menuWrapper___jaBEt:last-child {
  margin-right: 0;
}

.styles__menuWrapper___jaBEt:nth-child(3n) {
  margin-right: 0;
  float: right;
}

.styles__menuWrapper___jaBEt:nth-child(3n + 1) {
  clear: both;
}

.styles__navigationMenuWrapper___LKJbd {
  position: fixed;
  width: 452.86px;
}

@media (max-width: 1440px) {

.styles__navigationMenuWrapper___LKJbd {
    max-width: 31%;
    right: 20px;
}
  }

.styles__row___WjfKe {
  display: flex;
  flex-direction: row;
  width: 100%;
}

.styles__sectionTitle___L8F0G {
}

.styles__tabList___mGa1G {
  background: none;
  color: textLight;
  height: 100%;
  font-size: 16px;
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-flow: wrap;
  list-style: none;
  border-bottom: 1px solid #e1e1e1;
  margin: 10px 0 20px;
  padding: 0;
}
`, "",{"version":3,"sources":["webpack://./universal/routes/Protected/PotentialClient/components/Main/styles.css"],"names":[],"mappings":"AAGE;IACE,gBAAgB;IAChB,WAAW;IACX,+BAA+B;EACjC;;AAEA;IACE,UAAU;IACV,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,0BAA0B;EAC5B;;AAGF;EAEE,aAAa;EACb,kBAAkB;AACpB;;AAEA;AAEA;;AAEA;EACE,WAAW;AACb;;AAEA;EAEE,aAAwB;EAAxB,mBAAwB;EAExB,oBAAoB;EACpB,iBAAiB;AACnB;;AANA;EAGE,WAAsB;EAAtB,cAAsB;AAGxB;;AANA;EAGE,WAAsB;EAAtB,cAAsB;EAAtB,WAAsB;AAGxB;;AAEA;EACE,aAA2B;EAA3B,wBAA2B;AAC7B;;AAEA;AAEA;;AAEA;AAEA;;AAEA;AAEA;;AAEA;EACE,8CAAgB;AAClB;;AAFA;EACE,WAAgB;EAAhB,kBAAgB;EAAhB,WAAgB;AAClB;;AAFA;EACE,eAAgB;AAClB;;AAFA;EACE,eAAgB;EAAhB,YAAgB;AAClB;;AAFA;EACE,WAAgB;AAClB;;AAEA;EAEE,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,oCAAoC;EACpC,gBAAgB;EAEhB,cAAc;AAMhB;;AAJE;IACE,iBAAiB;IACjB,gBAAgB;EAClB;;AAGF;EACE,cAAc;EAEd,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,8CAAgB;AAClB;;AAFA;EACE,WAAgB;EAAhB,kBAAgB;EAAhB,WAAgB;AAClB;;AAFA;EACE,eAAgB;AAClB;;AAFA;EACE,eAAgB;EAAhB,YAAgB;AAClB;;AAFA;EACE,WAAgB;AAClB;;AAEA;EACE,eAAe;EACf,eAAe;AAMjB;;AAJE;;AAJF;IAKI,cAAc;IACd,WAAW;AAEf;EADE;;AAGF;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;AAEA;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,mBAAmB;EACnB,UAAU;AACZ","sourcesContent":["@value helpers: \"styles/helpers.css\";\n\n:global {\n  .react-tabs__tab--selected {\n    font-weight: 600;\n    color: text;\n    border-bottom: 3px solid gtBlue;\n  }\n\n  .react-tabs__tab {\n    opacity: 1;\n    height: 50px;\n    cursor: pointer;\n    padding: 16px 10px;\n    text-transform: capitalize;\n  }\n}\n\n.actionButton {\n  composes: button from helpers;\n  display: flex;\n  align-self: center;\n}\n\n.cardMarginBot {\n  composes: cardMarginBot from helpers;\n}\n\n.fullWidth {\n  width: 100%;\n}\n\n.contentContainer {\n  composes: content-container from helpers;\n  lost-flex-container: row;\n  lost-utility: clearfix;\n  padding-bottom: 20px;\n  padding-top: 20px;\n}\n\n.form {\n  lost-flex-container: column;\n}\n\n.formItem {\n  composes: formItem from helpers;\n}\n\n.formItemHalf {\n  composes: formItemHalf from helpers;\n}\n\n.formItemQuarter {\n  composes: formItemQuarter from helpers;\n}\n\n.formWrapper {\n  lost-column: 2/3;\n}\n\n.headerSection {\n  composes: section from helpers;\n  min-height: 80px;\n}\n\n.headerTitle {\n  float: left;\n}\n\n.link {\n  background: rgba(255, 255, 255, 0.7);\n  box-shadow: none;\n  composes: sectionTitle from helpers;\n  display: block;\n\n  &:hover {\n    background: white;\n    box-shadow: none;\n  }\n}\n\n.menuLink {\n  color: gtGreen;\n  composes: link;\n  display: flex;\n  align-self: center;\n}\n\n.menuWrapper {\n  lost-column: 1/3;\n}\n\n.navigationMenuWrapper {\n  position: fixed;\n  width: 452.86px;\n\n  @media (max-width: 1440px) {\n    max-width: 31%;\n    right: 20px;\n  }\n}\n\n.row {\n  display: flex;\n  flex-direction: row;\n  width: 100%;\n}\n\n.sectionTitle {\n  composes: sectionTitle from helpers;\n}\n\n.tabList {\n  background: none;\n  color: textLight;\n  height: 100%;\n  font-size: 16px;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  flex-flow: wrap;\n  list-style: none;\n  border-bottom: 1px solid #e1e1e1;\n  margin: 10px 0 20px;\n  padding: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"helpers": `"styles/helpers.css"`,
	"actionButton": `styles__actionButton___YUXCj ${___CSS_LOADER_ICSS_IMPORT_0___.locals["button"]}`,
	"cardMarginBot": `styles__cardMarginBot___rBx4s ${___CSS_LOADER_ICSS_IMPORT_0___.locals["cardMarginBot"]}`,
	"fullWidth": `styles__fullWidth___qCiP5`,
	"contentContainer": `styles__contentContainer___bsCgu ${___CSS_LOADER_ICSS_IMPORT_0___.locals["content-container"]}`,
	"form": `styles__form___A4MuD`,
	"formItem": `styles__formItem___jVahs ${___CSS_LOADER_ICSS_IMPORT_0___.locals["formItem"]}`,
	"formItemHalf": `styles__formItemHalf___UzKer ${___CSS_LOADER_ICSS_IMPORT_0___.locals["formItemHalf"]}`,
	"formItemQuarter": `styles__formItemQuarter___VKfpu ${___CSS_LOADER_ICSS_IMPORT_0___.locals["formItemQuarter"]}`,
	"formWrapper": `styles__formWrapper___v3Svi`,
	"headerSection": `styles__headerSection___jqFD0 ${___CSS_LOADER_ICSS_IMPORT_0___.locals["section"]}`,
	"headerTitle": `styles__headerTitle___va7Nk`,
	"link": `styles__link___bcA_J ${___CSS_LOADER_ICSS_IMPORT_0___.locals["sectionTitle"]}`,
	"menuLink": `styles__menuLink___Txbgw styles__link___bcA_J ${___CSS_LOADER_ICSS_IMPORT_0___.locals["sectionTitle"]}`,
	"menuWrapper": `styles__menuWrapper___jaBEt`,
	"navigationMenuWrapper": `styles__navigationMenuWrapper___LKJbd`,
	"row": `styles__row___WjfKe`,
	"sectionTitle": `styles__sectionTitle___L8F0G ${___CSS_LOADER_ICSS_IMPORT_0___.locals["sectionTitle"]}`,
	"tabList": `styles__tabList___mGa1G`
};
export default ___CSS_LOADER_EXPORT___;
